import React from "react";

const CancelButton = ({
  text,
  customClass,
  disabled,
  onClick,
  submit,
  type,
}) => {
  return (
    <>
      <button
        type={type}
        disabled={disabled}
        submit={submit}
        // disabled={disabled}
        onClick={onClick}
        className={`w-fit bg-gray-200 text-gray-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center hover:shadow-md ${customClass}`}
      >
        {text}
      </button>
    </>
  );
};

export default CancelButton;
